export default __webpack_public_path__ + "static/TTCommons-Light-7380df232a2004b6ac52d329121f8c98.woff";